import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const RequisitionManagement = lazy(() =>
  import("../pages/RequisitionManagement"),
);
const NewJobRequistion = lazy(() => import("../pages/NewJobRequistion"));
const ViewRequisition = lazy(() => import("../pages/ViewRequisition"));
const RequestsHistory = lazy(() => import("../pages/RequestsHistory"));
const ViewRequestModification = lazy(() =>
  import("../pages/ViewRequestModification"),
);

export const jobRequisitionRoutes = [
  {
    path: "/job-requisition",

    children: [
      {
        path: "",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <RequisitionManagement />
          </Suspense>
        ),
      },
      {
        path: "new",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <NewJobRequistion />
          </Suspense>
        ),
      },
      {
        path: "history",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <RequestsHistory />
          </Suspense>
        ),
      },
      // Drafts open in the wizard ("Continue editing").
      {
        path: ":id/edit",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <NewJobRequistion />
          </Suspense>
        ),
      },
      // Submitted requisitions open read-only; drafts redirect to the wizard.
      {
        path: ":id",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <ViewRequisition />
          </Suspense>
        ),
      },
      {
        path: ":id/modification",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <ViewRequestModification />
          </Suspense>
        ),
      },
    ],
  },
];
